import Chart from './Chart'

export default Chart
// eslint-disable-next-line import/export
export * from './Chart'
